import { PAGE_CODES } from 'constants/pageCodes';
import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

export class DevToolsPaths {
  static obLogger = new EnhancedPath('/dev-tools/ob-logger');
}

const devToolsRoutesConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: DevToolsPaths.obLogger.path,
      component: lazyWithRetry(() => import('app/pages/devTools/obLogger')),
      pageCode: PAGE_CODES.INTERNAL_HTTP_REQUEST_LOG,
    },
  ],
};

export default devToolsRoutesConfig;
